import { faroCoreApiClient } from "@api/faro-core-api-client";
import { useCompanyId } from "@context-providers/company-id-provider";
import { FaroCoreApiTypes } from "@stellar/core-api-client";
import { useEffect, useState } from "react";

interface ReturnProps {
  /** All the Stripe products in the company */
  stripeProducts: FaroCoreApiTypes.StripeProduct[];

  /** Whether the Stripe products are still being loaded */
  isLoading: boolean;
}

/** A hook that fetches all the Stripe products in the company */
export function useStripeProducts(): ReturnProps {
  const companyId = useCompanyId();

  const [stripeProducts, setStripeProducts] = useState<
    FaroCoreApiTypes.StripeProduct[]
  >([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  // Fetch all the Stripe products in the company
  useEffect(() => {
    async function fetchStripeProducts(): Promise<void> {
      const products = await faroCoreApiClient.company.getStripeProducts({
        companyId,
      });

      if (products && products.length > 0) {
        setStripeProducts(products);
      }

      setIsLoading(false);
    }
    void fetchStripeProducts();
  }, [companyId]);

  return { stripeProducts, isLoading };
}
